/*
 * @Author: your name
 * @Date: 2021-09-16 11:31:05
 * @LastEditTime: 2023-07-20 14:57:32
 * @LastEditors: hjp hjp@hjp.com
 * @Description: In User Settings Edit
 * @FilePath: \yelink-ecm-portal-web\src\utils\request.js
 */
import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import qs from 'qs'
import handleUnauthorized from '@/utils/handleUnauthorized'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API // url = base url + request url
  // headers: {
  //   // 公共请求头配置，本项目请求头大多数接口是这个，所以这里可以配置一下，对于特殊接口单独配置
  //   'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
  // }
})

service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }
    if (config.method === 'get') {
      config.paramsSerializer = function(params) {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
    // } else if ((config.method === 'put' && config.headers['Content-Type'] !== 'multipart/form-data') || (config.method === 'post' && config.headers['Content-Type'] !== 'multipart/form-data' && config.headers['Content-Type'] !== 'application/json')) {
    //   config.data = qs.stringify(config.data) // 配套application/x-www-form-urlencoded使用
    // }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // if the custom code is not 20000, it is judged as an error.
    /* if (res.code !== 20000) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }*/
    if (+response.data.code !== 0) {
      Message({
        message: response.data.message || 'Error',
        type: 'warning',
        duration: 5 * 1000
      })
      return Promise.reject(new Error(response.data.message || 'Error'))
      // return response.data.message
    }
    return response.data.data
  },
  error => {
    // 401(token 过期/被踢) → 跳 keycloak 登录页
    if (error.response && error.response.status === 401) {
      handleUnauthorized()
      return Promise.reject(error)
    }
    // console.log(error.response)
    // const data = error.response.data
    // if (data.message !== '') {
    //   error.message = data.message
    // }
    console.log('err ' + error)
    // for debug
    Message({
      message: error.message,
      type: 'error',
      center: true,
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
